export default {
    "type": "FeatureCollection",
    "name": "dachau",
    "crs": {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
        }
    },
    "features": [{
        "type": "Feature",
        "properties": {
            "ADE": 6,
            "GF": 4,
            "BSG": 1,
            "RS": "091740115115",
            "AGS": "09174115",
            "SDV_RS": "091740115115",
            "GEN": "Dachau",
            "BEZ": "Stadt",
            "IBZ": 61,
            "BEM": "--",
            "NBD": "ja",
            "SN_L": "09",
            "SN_R": "1",
            "SN_K": "74",
            "SN_V1": "01",
            "SN_V2": "15",
            "SN_G": "115",
            "FK_S3": "R",
            "NUTS": "DE217",
            "RS_0": "091740115115",
            "AGS_0": "09174115",
            "WSK": "2009\/01\/01",
            "DEBKG_ID": "DEBKGDL20000E40C",
            "destatis": {
                "RS": "091740115115",
                "area": 34.960000,
                "area_date": "31.12.2014",
                "population": 45985,
                "population_m": 22452,
                "population_w": 23533,
                "population_density": 1315,
                "zip": "85221",
                "center_lon": "11,441663",
                "center_lat": "48,257879",
                "travel_key": "T24",
                "travel_desc": "Münchener Umland",
                "density_key": "02",
                "density_desc": "mittlere Besiedlungsdichte"
            },
            "wikipedia": {
                "cid": "http:\/\/www.wikidata.org\/entity\/Q7077",
                "name": "Dachau",
                "AGS": "09174115",
                "_official_website": "http:\/\/www.dachau.de\/",
                "_local_dialing_code": "08131",
                "_postal_code": "85221",
                "_image": "http:\/\/commons.wikimedia.org\/wiki\/Special:FilePath\/Rathaus%20Dachau-1.jpg",
                "_head_of_government": "http:\/\/www.wikidata.org\/entity\/Q16064422"
            }
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [11.409027950553233, 48.30988065940678],
                    [11.419850044002523, 48.309662906365375],
                    [11.422309551963838, 48.303879320342659],
                    [11.431454279857446, 48.302952362722188],
                    [11.431199077225651, 48.296368799609333],
                    [11.424995455197273, 48.291619471094187],
                    [11.425335112029337, 48.282481648175981],
                    [11.445119480265056, 48.280549449742225],
                    [11.455411075091696, 48.283436476368294],
                    [11.462204807057773, 48.290024051232372],
                    [11.46316623679326, 48.283407140266057],
                    [11.471078350509703, 48.281180073509255],
                    [11.474328142147922, 48.274323909715392],
                    [11.494797770895923, 48.275954026218542],
                    [11.502321169721077, 48.258044500940805],
                    [11.500616609396111, 48.253025022787448],
                    [11.469819084836947, 48.255332618809291],
                    [11.46908943921868, 48.241496260673827],
                    [11.458392798342672, 48.241270853070588],
                    [11.455101696198847, 48.236408870973506],
                    [11.450573097278179, 48.237635507719688],
                    [11.429135241940896, 48.227056607281874],
                    [11.418732036107956, 48.229498251498107],
                    [11.421419597421734, 48.233149399929637],
                    [11.417448028562916, 48.244659726231035],
                    [11.412289276654679, 48.243834996092566],
                    [11.410584811378595, 48.24620020155001],
                    [11.414415202786641, 48.252359494580283],
                    [11.4067967019968, 48.25610343931438],
                    [11.413208398499497, 48.258718178420956],
                    [11.408902093743555, 48.265832244514485],
                    [11.411212182797351, 48.271306641467369],
                    [11.418416830374555, 48.2727123323412],
                    [11.405081393294955, 48.279338684018192],
                    [11.395475585938032, 48.289636891432814],
                    [11.384370117606899, 48.293688323370716],
                    [11.392311098420622, 48.296177776261068],
                    [11.397006672503265, 48.302424461929],
                    [11.396047943503953, 48.308959859874157],
                    [11.405639541512151, 48.311477482619118],
                    [11.409027950553233, 48.30988065940678]
                ]
            ]
        }
    }]
}